import { useQuery } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { ApiUsertagElFindParams } from '@/apis/swaggers/v2/v2-swagger'
import { QUERY_KEY } from '@/apis/swaggers/swagger-docs'
import { QueryComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type QueryParams = QueryComposableParams<ApiUsertagElFindParams, unknown>

const fetchUserTagList = async (params: ApiUsertagElFindParams) => {
  const { data } = await apiClient.v2.apiUsertagElFind(params);
  return checkApiResponse(data);
}

export const userTagKeys = {
  all: [QUERY_KEY.v2apiUsertagElFind] as const,
  list: (params: ApiUsertagElFindParams) => [...userTagKeys.all, params] as const,
}

/** 명령형(await) 호출용 쿼리 정의 — `queryClient.fetchQuery(userTagFindQueryOptions(params))` */
export const userTagFindQueryOptions = (params: ApiUsertagElFindParams) => ({
  queryKey: userTagKeys.list(params),
  queryFn: () => fetchUserTagList(params),
})

export const useUserTagFindQuery = ({ params, options }: QueryParams) => {
  return useQuery(() => ({
    queryKey: userTagKeys.list(resolveMaybeGetter(params)),
    queryFn: () => fetchUserTagList(resolveMaybeGetter(params)),
    ...resolveMaybeGetter(options ?? {}),
  }))
}
